import React from 'react';
import styles from './License.module.css';
import { asView } from '../routing/View';
import { Panel } from '../layout/Panel';
import { SimpleGuard } from '../ui/SimpleGuard';

export interface LicenseProps {
}

export const License: React.FC<LicenseProps> = (props) => {
  return (
    <Panel>
      <p>
        By default, all code is licensed according to this license. If there is
        no explicit statement declaring a different license, this license applies.
      </p>
      <div className={styles.codeWrap}>
        <pre className={styles.code}>
          {[
            'ISC License',
            '',
            'Copyright (c) 2020, Codaer',
            '',
            [
              'Permission to use, copy, modify, and/or distribute this software for any',
              'purpose with or without fee is hereby granted, provided that the above',
              'copyright notice and this permission notice appear in all copies.',
            ].join(' '),
            '',
            [
              'THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES',
              'WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF',
              'MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR',
              'ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES',
              'WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN',
              'ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF',
              'OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.',
            ].join(' '),
          ].join('\n')}
        </pre>
      </div>
      <p>
        If there are any additional questions, feel free to contact our
        licensing department:
        <SimpleGuard
          description='email'
          guardKey='0B9BD5C4-068E-4004-8E68-ABA8E940E97A'
          guardValue='nKucp7KorKKUcJmnqY6Zol6XnKU='
        />
      </p>
    </Panel>
  );
};

export const LicenseView = asView(License);